export default {
  crypto: {
    signature: '签名算法',
    algorithm: '算法',
    value: '值'
  }
}
